import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from './api';
import { useAuth } from './AuthContext';

export function SongNotes() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [song, setSong] = useState(null);
    const [notes, setNotes] = useState([]);
    const [newNote, setNewNote] = useState('');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    const load = () => {
        api.get('/songs').then((res) => {
            setSong(res.data.find((s) => String(s.id) === id));
        });
        api.get(`/songs/${id}/notes`).then((res) => setNotes(res.data));
    };

    useEffect(() => { load(); }, [id]);

    const addNote = async (e) => {
        e.preventDefault();
        if (!newNote.trim()) return;
        await api.post(`/songs/${id}/notes`, { content: newNote });
        setNewNote('');
        load();
    };

    const deleteNote = async (noteId) => {
        await api.delete(`/songs/${id}/notes/${noteId}`);
        load();
    };

    return (
        <div className="song-notes-page">
            <button onClick={() => navigate('/')}>&lt; Back to Songs</button>
            <h2>{song ? song.title : 'Song'} — Notes</h2>

            {isAdmin && (
                <form onSubmit={addNote} className="add-note-form">
                    <textarea
                        placeholder="Add a note..."
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        rows={4}
                    />
                    <button type="submit">Add Note</button>
                </form>
            )}

            <div className="notes-list">
                {notes.length === 0 && <p>No notes yet</p>}
                {notes.map((note) => (
                    <div key={note.id} className="note-item">
                        <div className="note-content">{note.content}</div>
                        <div className="note-meta">
                            {note.username} — {new Date(note.created_at).toLocaleString()}
                        </div>
                        {isAdmin && <button onClick={() => deleteNote(note.id)}>Delete</button>}
                    </div>
                ))}
            </div>
        </div>
    );
}